import { useFetchFundDetailsPerformanceQuery } from '@/store/fundDetails/services/fundDetailsApi';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import { endpoints } from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/performanceEndpoints';
import useHelpers from 'hooks/helpers';
import { useI18n } from 'next-localization';
import FundDetailsDiscretePerformanceTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsDiscretePerformanceTable';

const FundDetailsDiscreteTab = () => {
  const payload = usePayload();
  const { getErrorDictionary } = useHelpers();
  const { t } = useI18n();
  const { data, isLoading, error } = useFetchFundDetailsPerformanceQuery({
    ...payload,
    endpoint: endpoints.DISCRETE,
  });
  return (
    <FundDetailsTabRow fullWidth className="mt-4">
      {isLoading ? (
        <FundDetailsTabSkeleton />
      ) : error ? (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
      ) : (
        <FundDetailsDiscretePerformanceTable tabData={data.content} />
      )}
    </FundDetailsTabRow>
  );
};

export default FundDetailsDiscreteTab;
